import { z } from 'zod'
import {
  Address,
  HexNumber,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { LinkedContractsFactoryAddress } from '../../../cross-chain-deployment/LinkedContractsFactoryAddress'

export const LinkedContractsFactoryAddressSchema = z.string()

type LinkedContractsFactoryAddressReportText = z.infer<
  typeof LinkedContractsFactoryAddressSchema
>

export function mapDomainToReportText(
  calldata: LinkedContractsFactoryAddress
): LinkedContractsFactoryAddressReportText {
  return calldata.getChecksumValue()
}

export function mapReportTextToDomain(
  reportText: LinkedContractsFactoryAddressReportText
): LinkedContractsFactoryAddress {
  return LinkedContractsFactoryAddress.create({
    linkedContractsFactoryAddressValue: Address.create({
      addressValue: HexNumber.create({
        hexNumberValue: reportText,
      }),
    }),
  })
}
